// @flow
import React, {PureComponent} from 'react';
import StaticAlertMetric from './StaticAlertMetric';
import '../alertContent.module.scss';

type PropTypes = {
  alert: Object,
  uiGroupName: string,
  getWrapperStyle: Function,
  queryParams: Object,
  isSingleLine: boolean,
  specialHeader: boolean,
};

class StaticAlert extends PureComponent {
  props: PropTypes;

  componentDidMount() {
    // eslint-disable-next-line react/no-string-refs
    const alertContentHeight = this.refs.staticAlertMetric.clientHeight;
    this.props.getWrapperStyle(alertContentHeight);
  }

  render() {
    const {alert, uiGroupName, queryParams, isSingleLine, specialHeader} = this.props;

    return (
      // eslint-disable-next-line react/no-string-refs
      <div styleName="alert-content" ref="staticAlertMetric">
        <div styleName="sep" />
        {alert.metrics.map((m) => (
          <StaticAlertMetric
            metric={m}
            alertId={alert.id}
            uiGroupName={uiGroupName}
            startDate={m.displayStartTime}
            endDate={m.displayEndTime}
            timeScale={alert.timeScale}
            key={m.id}
            queryParams={queryParams}
            isSingleLine={isSingleLine}
            specialHeader={specialHeader}
          />
        ))}
      </div>
    );
  }
}

export default StaticAlert;
